import React, { createContext, type Dispatch } from 'react';
import { type State } from './Store'
import { defaultState } from './Store';

export const AuthenticationContext = createContext<State>(defaultState);
export const AuthenticationDispatchContext = createContext<Dispatch<any>>(() => { });
